module.exports = __webpack_public_path__ + "static/media/85386.5aeddc56.jpg";